export enum PropertyType {
  APARTMENT = "apartment",
  HOUSE = "house",
  OFFICE = "office",
  COMMERCIAL = "commercial",
  LAND = "land",
}

export enum PropertyStatus {
  AVAILABLE = "available",
  OCCUPIED = "occupied",
  SOLD = "sold",
  PENDING = "pending",
  MAINTENANCE = "maintenance",
}

export interface Property {
  propertyUUID: string;
  name: string;
  description?: string;
  type: PropertyType;
  status: PropertyStatus;
  price: number;
  currency: "USD";
  address?: string;
  city?: string;
  postalCode?: string;
  area?: number;
  rooms?: number;
  bathrooms?: number;
  floor?: number;
  totalFloors?: number;
  yearBuilt?: number;
  features?: string[];
  images?: {
    fullSize: {
      url: string;
      width: number;
      height: number;
      size: number;
    };
    thumbnail: {
      url: string;
      width: number;
      height: number;
      size: number;
    };
    order: number;
  }[];
  ownerUUID: string;
  managerUUID?: string;
  geoLocation?: {
    type: string;
    coordinates: [number, number];
  };
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  lastStatusChange?: string;
}



export const PROPERTY_TYPE_NAMES: Record<PropertyType, string> = {
  [PropertyType.APARTMENT]: "Apartment",
  [PropertyType.HOUSE]: "House",
  [PropertyType.OFFICE]: "Office",
  [PropertyType.COMMERCIAL]: "Commercial",
  [PropertyType.LAND]: "Land",
};

export const PROPERTY_STATUS_NAMES: Record<PropertyStatus, string> = {
  [PropertyStatus.AVAILABLE]: "Available",
  [PropertyStatus.OCCUPIED]: "Occupied",
  [PropertyStatus.SOLD]: "Sold",
  [PropertyStatus.PENDING]: "Pending",
  [PropertyStatus.MAINTENANCE]: "Maintenance",
};

export enum PropertySortFieldEnum {
  NAME = 'name',
  PRICE = 'price',
  AREA = 'area',
  ROOMS = 'rooms',
  CREATED_AT = 'createdAt',
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
} 